import { By } from 'selenium-webdriver';
import { DriverLike, register } from '@oracle/oraclejet-webdriver';
import { BadgeWebElement } from './BadgeWebElement';
export { BadgeWebElement };

/**
 * Retrieve an instance of [BadgeWebElement](../classes/BadgeWebElement.html).
 * @example
 * ```javascript
 * import { findBadge } from '@oracle/oraclejet-core-pack/webdriver';
 * const el = await findBadge(driver, By.id('my-oj-c-badge'));
 * ```
 * @param driver A WebDriver/WebElement instance from where the element will be
 * searched. If WebDriver is passed, the element will be searched globally in the
 * document. If WebElement is passed, the search will be relative to this element.
 * @param by The locator with which to find the element
 */
export async function findBadge(driver: DriverLike, by: By): Promise<BadgeWebElement> {
  const webEl = await driver.findElement(by);
  // Check that the element is of type BadgeWebElement
  if (!(webEl instanceof BadgeWebElement)) {
    const tagName = await webEl.getTagName();
    let supplemental = '';
    if (webEl.constructor.name === 'BadgeWebElement') {
      supplemental = 'You likely have multiple installations of this package.';
    }
    throw Error(
      `findBadge(${by}) created ${webEl.constructor.name} for <${tagName}>, but expected ${BadgeWebElement.name}. ${supplemental}`
    );
  }
  return webEl;
}

register('oj-c-badge', BadgeWebElement);
